import blocklists from "../validation/blocklists.json";

export const CORPORATE_TRIAL_EMAIL_MESSAGE =
  "Sorry, free trials are only available for valid corporate email addresses.";

const personalEmailDomains = new Set(
  blocklists.personal_email_domains.map((domain) => domain.toLowerCase())
);
const disposableEmailDomains = new Set(
  blocklists.disposable_email_domains.map((domain) => domain.toLowerCase())
);
const genericCompanyNames = new Set(
  blocklists.generic_company_names.map((name) => name.toLowerCase())
);

export const extractEmailDomain = (email) => {
  if (!email || !email.includes("@")) return "";
  return email.split("@").pop().trim().toLowerCase();
};

export const normalizeCompanyName = (companyName) =>
  (companyName || "").trim().toLowerCase().replace(/\s+/g, " ");

export const validateWorkEmail = (email) => {
  const emailDomain = extractEmailDomain(email);
  if (!emailDomain) {
    return { ok: false, error: CORPORATE_TRIAL_EMAIL_MESSAGE };
  }

  if (personalEmailDomains.has(emailDomain)) {
    return { ok: false, error: CORPORATE_TRIAL_EMAIL_MESSAGE };
  }

  if (disposableEmailDomains.has(emailDomain)) {
    return { ok: false, error: CORPORATE_TRIAL_EMAIL_MESSAGE };
  }

  return { ok: true, error: null };
};

export const validateCompanyName = (companyName, email = "") => {
  const normalized = normalizeCompanyName(companyName);

  if (normalized.length < 2) {
    return { ok: false, error: "Please enter your company name" };
  }

  if (normalized.length > 40) {
    return { ok: false, error: "Company name must be 40 characters or less" };
  }

  if (genericCompanyNames.has(normalized)) {
    return { ok: false, error: "Please enter your real company name" };
  }

  if (/^[0-9]+$/.test(normalized)) {
    return { ok: false, error: "Please enter a valid company name" };
  }

  if (new Set(normalized.replace(/\s/g, "")).size === 1) {
    return { ok: false, error: "Please enter a valid company name" };
  }

  if (email && email.includes("@")) {
    const localPart = email.split("@")[0].trim().toLowerCase();
    if (localPart && localPart === normalized.replace(/\s/g, "")) {
      return {
        ok: false,
        error: "Please enter your company name, not your email username",
      };
    }
  }

  return { ok: true, error: null };
};

export const validateBusinessRegistration = (email, companyName) => {
  const emailResult = validateWorkEmail(email);
  if (!emailResult.ok) return emailResult;

  return validateCompanyName(companyName, email);
};

export const isCorporateTrialEmailError = (message) => {
  if (!message) return false;
  const normalized = message.toLowerCase();
  return (
    normalized.includes("corporate email") ||
    normalized.includes("work email") ||
    normalized.includes("verify your company") ||
    normalized.includes("valid company mail domain")
  );
};

export const normalizeRegistrationError = (message) => {
  if (isCorporateTrialEmailError(message)) {
    return CORPORATE_TRIAL_EMAIL_MESSAGE;
  }
  return message;
};
